module.exports = {"370634001":"南长山街道","370634101":"砣矶镇","370634201":"北长山乡","370634202":"黑山乡","370634203":"大钦岛乡","370634204":"小钦岛乡","370634205":"南隍城乡","370634206":"北隍城乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/370634.json
// module id = 1294
// module chunks = 0